<div class="modal fade" id="modalStoreWarehouse" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">Chọn Cửa Hàng Và Kho Hàng Đồng Bộ</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-sm-12 d-flex justify-content-between flex-wrap mb-5">
                    <div class="col-sm-9 d-flex flex-column gap-3">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap justify-content-between">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :error-text="dataSelect.store_id.error"
                                        :is-error="dataSelect.store_id.isError"
                                        :label="dataSelect.store_id.label"
                                        :id="dataSelect.store_id.id"
                                        @inputValue="onChange($event, dataSelect.store_id.id)"
                                        :placeholder="dataSelect.store_id.placeholder"
                                        :value-default="dataSelect.store_id.value"
                                        :required="dataSelect.store_id.required"
                                        @blur="validateForm($event, dataSelect.store_id.id)"
                                        :options="dataSelect.store_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataSelect.warehouse_id.label"
                                        :id="dataSelect.warehouse_id.id"
                                        @inputValue="onChange($event, dataSelect.warehouse_id.id)"
                                        :placeholder="dataSelect.warehouse_id.placeholder"
                                        :value-default="dataSelect.warehouse_id.value"
                                        :error-text="dataSelect.warehouse_id.error"
                                        :is-error="dataSelect.warehouse_id.isError"
                                        :required="dataSelect.warehouse_id.required"
                                        @blur="validateForm($event, dataSelect.warehouse_id.id)"
                                        :options="dataSelect.warehouse_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSubmit" @click="applyStoreWarehouseSelected"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
